module.exports = "/_next/static/images/icon-sign-entry-61f8aa1d.png";